<form [formGroup]="salesPurchaseFilterForm" class="login-filter-form">
    <div class="flexbox aff-info">
        <div class="flexbox aff-info-inner" style="width: 100%;">
            <div class="flexbox ">
                <div class="text-input-fiel">
                     <ng-container *ngIf="isLocaleDateFormat">
                         <input class="input-ui" searchtabindex="1" formControlName="start_date" id="start_date"
                             type="date" />
                     </ng-container>
                        <ng-container *ngIf="!isLocaleDateFormat && salesPurchaseFilterForm.controls.start_date">
                <app-date-time-input
                formControlName="start_date"
                [dateFormat]="dateFormat"
                [fieldController]="salesPurchaseFilterForm.controls.start_date"
                class="new-date-input"
                classes="inv-date-input" 
                tIndex="2"
                ></app-date-time-input>
          </ng-container>
                    <label for="start_date">Starting Date</label>
                </div>
                <div class="text-input-fiel">
                              <ng-container *ngIf="isLocaleDateFormat">
                    <input class="input-ui" searchtabindex="2" formControlName="end_date" id="end_date" type="date" />
                    </ng-container>
                    <ng-container *ngIf="!isLocaleDateFormat && salesPurchaseFilterForm.controls.end_date">
                <app-date-time-input
                formControlName="end_date"
                [dateFormat]="dateFormat"
                [fieldController]="salesPurchaseFilterForm.controls.end_date"
                class="new-date-input"
                classes="inv-date-input" 
                tIndex="2"
                ></app-date-time-input>
          </ng-container>
                    <label for="end_date">Ending Date</label>
                </div>
            </div>


            <div class="d-flex mt-5 justify-content-center">
                <div class="input-fiel">
                    <button id="submitSearchForm" type="button" class="btn-style bg-purple mr-3" data-dismiss="modal"
                        searchtabindex="3" #searchButton (keyup.enter)="clickSearchButton()"
                        [disabled]="salesPurchaseFilterForm.invalid" (click)="search(salesPurchaseFilterForm.value)">
                        Search</button>
                    <button type="button" class="btn-style bg-green" id="resetSearchForm"
                        (click)="reset()">RESET</button>
                </div>
            </div>
        </div>
    </div>
</form>